<a class="notification-link" (click)="downloadFile()">{{
    'Dashboard::ClickHereToDownloadAqmAgentQuestionBasedReport' | abpLocalization
  }}</a>